/**
 * Auth State Slice
 * Manages authentication-related state
 * Note: Most auth logic is in AuthContext, this is for UI state
 */

export const createAuthSlice = (set, get) => ({
  // User roles and permissions (populated from AuthContext)
  userRoles: [],
  userPermissions: [],
  
  setUserRoles: (roles) => set({ userRoles: roles }),
  setUserPermissions: (permissions) => set({ userPermissions: permissions }),
  
  // Check if user has permission
  hasPermission: (permission) => {
    const { userPermissions } = get();
    return userPermissions.includes(permission);
  },
  
  // Check if user has role
  hasRole: (role) => {
    const { userRoles } = get();
    return userRoles.includes(role);
  },
});






